import { render, staticRenderFns } from "./ReviewsForItem.vue?vue&type=template&id=1c869c49&scoped=true"
import script from "./ReviewsForItem.vue?vue&type=script&lang=js"
export * from "./ReviewsForItem.vue?vue&type=script&lang=js"
import style0 from "./ReviewsForItem.vue?vue&type=style&index=0&id=1c869c49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c869c49",
  null
  
)

export default component.exports